
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("5XdNJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $f406723f6d998d4c$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4ZMmh = parcelRequire("4ZMmh");

var $6Pjzp = parcelRequire("6Pjzp");

var $7tc9a = parcelRequire("7tc9a");

var $8AI2A = parcelRequire("8AI2A");

var $ewM8s = parcelRequire("ewM8s");

var $3q3fP = parcelRequire("3q3fP");

var $a6ENB = parcelRequire("a6ENB");
parcelRequire("5cRlx");
var $4mfBs = parcelRequire("4mfBs");
const $f406723f6d998d4c$var$addOrUpdateInProgress = (state, ...newFiles)=>{
    const updatedFiles = newFiles.map((newFile)=>{
        const oldFile = state.filesInProgress.find((file)=>file.id === newFile.id);
        if (oldFile) return (0, $4ZMmh.defaults)({}, newFile, oldFile);
        return newFile;
    });
    const remainingValue = (0, $4ZMmh.reject)(state.filesInProgress, (file)=>newFiles.find((newFile)=>newFile.id === file.id) !== undefined);
    return (0, $4ZMmh.sortBy)(remainingValue.concat(updatedFiles), [
        (sortingFile)=>sortingFile.name,
        (sortingFile)=>sortingFile.id
    ]);
};
class $f406723f6d998d4c$var$Attachments extends $bSJIT.PureComponent {
    get uploadParams() {
        return {
            collection: this.props.collection
        };
    }
    onUploadStarted(mediaComponent) {
        return (data)=>{
            // Remove the old uploads and replace with the new ones.
            const files = data.files.map((file)=>({
                    id: file.id,
                    name: file.name,
                    size: file.size,
                    mimeType: file.type,
                    source: mediaComponent
                }));
            // Call onUploadStatusUpdate each time there is progress to report on a file
            if (this.state.mediaClientConfig !== null) {
                const mediaClient = new (0, $6Pjzp.MediaClient)(this.state.mediaClientConfig);
                data.files.forEach((file)=>{
                    const subscription = mediaClient.file.getFileState(file.id, {
                        collectionName: this.props.collection
                    }).subscribe({
                        next: (fileState)=>{
                            if (fileState.status !== 'uploading') {
                                subscription.unsubscribe();
                                return;
                            }
                            this.onUploadStatusUpdate(fileState);
                        },
                        error: (error)=>{
                            if (error !== 'canceled') (0, $a6ENB.reportError)(error, {
                                message: `Failed uploading file.`
                            });
                            subscription.unsubscribe();
                        }
                    });
                });
            }
            this.setState((state)=>({
                    filesInProgress: $f406723f6d998d4c$var$addOrUpdateInProgress(state, ...files)
                }));
            this.props.blockFormSubmission && this.props.blockFormSubmission(true);
        };
    }
    static getDerivedStateFromProps(props, state) {
        // Need to ensure that mediaClientConfig doesn't change between renders as otherwise
        // getMediaClient() won't give us the same media client used by the media-picker components
        if (props.authProvider !== state.prevAuthProvider) return {
            prevAuthProvider: props.authProvider,
            mediaClientConfig: {
                authProvider: props.authProvider,
                useSha256ForUploads: true
            }
        };
        return null;
    }
    componentDidUpdate() {
        if (!this.state.filesInProgress.length) {
            var _this$props$blockForm, _this$props3;
            (_this$props$blockForm = (_this$props3 = this.props).blockFormSubmission) === null || _this$props$blockForm === void 0 || _this$props$blockForm.call(_this$props3, false);
        }
    }
    render() {
        const { mediaClientConfig: mediaClientConfig } = this.state;
        if (mediaClientConfig === null) return null;
        return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, !this.props.disabled && /*#__PURE__*/ $bSJIT.createElement((0, $ewM8s.ClipboardLoader), {
            config: {
                uploadParams: this.uploadParams
            },
            mediaClientConfig: mediaClientConfig,
            onError: this.onUploadError,
            onPreviewUpdate: this.onUploadPreviewUpdate,
            onEnd: this.onUploadCompleted,
            onUploadsStart: this.onUploadStarted()
        }), !this.props.disabled && /*#__PURE__*/ $bSJIT.createElement((0, $7tc9a.DropzoneLoader), {
            config: {
                // Upgrading @atlaskit/platform; fix these violations.
                // eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-react-cc-render,@atlaskit/platform/no-direct-document-usage
                container: document.body,
                uploadParams: this.uploadParams
            },
            mediaClientConfig: mediaClientConfig,
            onCancelFn: this.saveCancelFunction('dropzone'),
            onError: this.onUploadError,
            onPreviewUpdate: this.onUploadPreviewUpdate,
            onEnd: this.onUploadCompleted,
            onUploadsStart: this.onUploadStarted('dropzone')
        }), /*#__PURE__*/ $bSJIT.createElement((0, $4mfBs.default), {
            mediaClientConfig: mediaClientConfig,
            disabled: this.props.disabled,
            hasError: this.props.hasError,
            uploadedAttachments: this.state.uploaded || [],
            uploadsInProgress: this.state.filesInProgress,
            failedUploads: this.state.failures,
            collection: this.props.collection,
            onBrowseClicked: this.showFileBrowser,
            onRemoveAttached: this.onRemoveFile,
            onRemoveError: this.onIgnoreError,
            onRemoveInProgress: this.onCancelUpload
        }), /*#__PURE__*/ $bSJIT.createElement((0, $8AI2A.BrowserLoader), {
            onCancelFn: this.saveCancelFunction('browser'),
            isOpen: this.state.isBrowserOpen,
            onClose: this.onBrowserClose,
            mediaClientConfig: mediaClientConfig,
            config: {
                multiple: true,
                uploadParams: this.uploadParams
            },
            onUploadsStart: this.onUploadStarted('browser'),
            onPreviewUpdate: this.onUploadPreviewUpdate,
            onEnd: this.onUploadCompleted,
            onError: this.onUploadError
        }));
    }
    constructor(...args){
        super(...args), this.state = {
            failures: [],
            filesInProgress: [],
            uploaded: [],
            isBrowserOpen: false,
            prevAuthProvider: null,
            mediaClientConfig: null
        }, this.cancelFunctions = new Map(), this.onUploadStatusUpdate = (data)=>{
            this.setState((state)=>({
                    filesInProgress: $f406723f6d998d4c$var$addOrUpdateInProgress(state, {
                        id: data.id,
                        name: data.name,
                        size: data.size,
                        mimeType: data.mimeType,
                        progress: Math.ceil(data.progress * 100)
                    })
                }));
        }, this.onUploadPreviewUpdate = (data)=>{
            this.setState((state)=>({
                    filesInProgress: $f406723f6d998d4c$var$addOrUpdateInProgress(state, {
                        id: data.file.id,
                        name: data.file.name,
                        size: data.file.size,
                        mimeType: data.file.type,
                        // @ts-ignore TypeScript upgrade 4.7.4
                        preview: (0, $3q3fP.isImagePreview)(data.preview) ? URL.createObjectURL(data.preview.file) : undefined
                    })
                }));
        }, this.onUploadCompleted = (data)=>{
            this.props.saveAttachment && this.props.saveAttachment(data.file.id).subscribe(()=>this.onAttachmentSaved(data.file), (error)=>this.onSaveAttachmentFailed(data.file, error));
        }, this.onUploadError = (data)=>{
            this.setState((state)=>{
                const fileInProgress = state.filesInProgress.find((file)=>file.id === data.fileId);
                if (fileInProgress) return {
                    filesInProgress: (0, $4ZMmh.reject)(state.filesInProgress, (file)=>file.id === data.fileId),
                    failures: state.failures.concat([
                        {
                            id: data.fileId,
                            name: fileInProgress.name,
                            size: fileInProgress.size,
                            mimeType: fileInProgress.mimeType,
                            error: data.error.description
                        }
                    ])
                };
                return null;
            });
        }, this.onAttachmentSaved = (savedFile)=>{
            this.setState((state)=>({
                    uploaded: (state.uploaded ?? []).concat([
                        {
                            id: savedFile.id,
                            name: savedFile.name,
                            size: savedFile.size,
                            mimeType: savedFile.type
                        }
                    ]),
                    filesInProgress: (0, $4ZMmh.reject)(state.filesInProgress, (file)=>file.id === savedFile.id)
                }), ()=>{
                var _this$props$onChange, _this$props;
                (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 || _this$props$onChange.call(_this$props, this.state.uploaded);
            });
        }, this.onSaveAttachmentFailed = (savedFile, errors)=>{
            this.setState((state)=>({
                    filesInProgress: (0, $4ZMmh.reject)(state.filesInProgress, (file)=>file.id === savedFile.id),
                    failures: state.failures.concat([
                        {
                            id: savedFile.id,
                            name: savedFile.name,
                            size: savedFile.size,
                            mimeType: savedFile.type,
                            error: errors
                        }
                    ])
                }));
        }, this.onCancelUpload = (fileId, source)=>{
            if (source) {
                var _this$cancelFunctions;
                (_this$cancelFunctions = this.cancelFunctions.get(source)) === null || _this$cancelFunctions === void 0 || _this$cancelFunctions(fileId);
            }
            this.setState((state)=>({
                    filesInProgress: (0, $4ZMmh.reject)(state.filesInProgress, (file)=>file.id === fileId)
                }));
        }, this.onIgnoreError = (fileId)=>{
            this.setState((state)=>({
                    failures: (0, $4ZMmh.reject)(state.failures, (file)=>file.id === fileId)
                }));
        }, this.onRemoveFile = (fileId)=>{
            this.setState((state)=>({
                    uploaded: (0, $4ZMmh.reject)(state.uploaded, (file)=>file.id === fileId)
                }), ()=>{
                var _this$props$onChange2, _this$props2;
                (_this$props$onChange2 = (_this$props2 = this.props).onChange) === null || _this$props$onChange2 === void 0 || _this$props$onChange2.call(_this$props2, this.state.uploaded);
            });
        }, this.showFileBrowser = ()=>{
            this.setState({
                isBrowserOpen: true
            });
        }, this.onBrowserClose = ()=>{
            this.setState({
                isBrowserOpen: false
            });
        }, this.saveCancelFunction = (source)=>(cancel)=>{
                this.cancelFunctions.set(source, cancel);
            };
    }
}
var $f406723f6d998d4c$export$2e2bcd8739ae039 = $f406723f6d998d4c$var$Attachments;

});
parcelRegister("7tc9a", function(module, exports) {
$parcel$export(module.exports, "DropzoneLoader", () => $a3a0cb02c40d3d21$export$66201d263cd6342);

var $bSJIT = parcelRequire("bSJIT");



class $a3a0cb02c40d3d21$export$66201d263cd6342 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).PureComponent {
    static #_ = this.displayName = 'AsyncDropzone';
    componentDidMount() {
        if (!this.state.Dropzone || !this.state.MediaPickerErrorBoundary) Promise.all([
            Promise.resolve((parcelRequire("1fspY"))),
            (parcelRequire("V4wSv")),
            (parcelRequire("agaIQ"))
        ]).then(([mediaClient, dropzoneModule, mediaPickerErrorBoundaryModule])=>{
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $a3a0cb02c40d3d21$export$66201d263cd6342.Dropzone = mediaClient.withMediaClient(dropzoneModule.Dropzone);
            $a3a0cb02c40d3d21$export$66201d263cd6342.MediaPickerErrorBoundary = mediaPickerErrorBoundaryModule.default;
            this.setState({
                Dropzone: $a3a0cb02c40d3d21$export$66201d263cd6342.Dropzone,
                MediaPickerErrorBoundary: $a3a0cb02c40d3d21$export$66201d263cd6342.MediaPickerErrorBoundary
            });
        }).catch(()=>{
        // TODO [MS-2272]: Add operational error to catch import error
        });
    }
    render() {
        const { Dropzone: Dropzone, MediaPickerErrorBoundary: MediaPickerErrorBoundary } = this.state;
        if (!Dropzone || !MediaPickerErrorBoundary) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(MediaPickerErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Dropzone, this.props));
    }
    constructor(...args){
        super(...args), this.state = {
            Dropzone: $a3a0cb02c40d3d21$export$66201d263cd6342.Dropzone,
            MediaPickerErrorBoundary: $a3a0cb02c40d3d21$export$66201d263cd6342.MediaPickerErrorBoundary
        };
    }
}

});
parcelRegister("V4wSv", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("6yyLO"),
    $kOunM("dwvI2")
]).then(()=>parcelRequire('esQLv'));

});

parcelRegister("agaIQ", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("gCHew").then(()=>parcelRequire('8gt2G'));

});


parcelRegister("8AI2A", function(module, exports) {
$parcel$export(module.exports, "BrowserLoader", () => $0b4bb44b5957561c$export$3ce634ac4a869e2c);

var $bSJIT = parcelRequire("bSJIT");


class $0b4bb44b5957561c$export$3ce634ac4a869e2c extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).PureComponent {
    static #_ = this.displayName = 'AsyncBrowser';
    componentDidMount() {
        this.mounted = true;
        if (!this.state.Browser) Promise.all([
            Promise.resolve((parcelRequire("1fspY"))),
            (parcelRequire("hTzgT"))
        ]).then(([mediaClient, browserModule])=>{
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $0b4bb44b5957561c$export$3ce634ac4a869e2c.Browser = mediaClient.withMediaClient(browserModule.Browser);
            if (this.mounted) this.setState({
                Browser: $0b4bb44b5957561c$export$3ce634ac4a869e2c.Browser
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        if (!this.state.Browser) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(this.state.Browser, this.props);
    }
    constructor(...args){
        super(...args), this.mounted = false, this.state = {
            Browser: $0b4bb44b5957561c$export$3ce634ac4a869e2c.Browser
        };
    }
}

});
parcelRegister("hTzgT", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("6yyLO"),
    $kOunM("eqf5q")
]).then(()=>parcelRequire('iB3wS'));

});


parcelRegister("ewM8s", function(module, exports) {
$parcel$export(module.exports, "ClipboardLoader", () => $11d77a6318f80c12$export$d7936799bf32b554);

var $bSJIT = parcelRequire("bSJIT");


class $11d77a6318f80c12$export$d7936799bf32b554 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).PureComponent {
    static #_ = this.displayName = 'AsyncClipboard';
    componentDidMount() {
        if (!this.state.Clipboard) Promise.all([
            Promise.resolve((parcelRequire("1fspY"))),
            (parcelRequire("53xKg"))
        ]).then(([mediaClient, clipboardModule])=>{
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $11d77a6318f80c12$export$d7936799bf32b554.Clipboard = mediaClient.withMediaClient(clipboardModule.Clipboard);
            this.setState({
                Clipboard: $11d77a6318f80c12$export$d7936799bf32b554.Clipboard
            });
        });
    }
    render() {
        if (!this.state.Clipboard) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(this.state.Clipboard, this.props);
    }
    constructor(...args){
        super(...args), this.state = {
            Clipboard: $11d77a6318f80c12$export$d7936799bf32b554.Clipboard
        };
    }
}

});
parcelRegister("53xKg", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("6yyLO"),
    $kOunM("2KVrZ")
]).then(()=>parcelRequire('jng1z'));

});


parcelRegister("3q3fP", function(module, exports) {
$parcel$export(module.exports, "isImagePreview", () => $2cb66b909bfbf90e$export$5fe5572478566289);
const $2cb66b909bfbf90e$export$5fe5572478566289 = (preview)=>!!preview.dimensions;

});

parcelRegister("5cRlx", function(module, exports) {
$parcel$export(module.exports, "AttachmentsDumb", () => (parcelRequire("4mfBs")).default);

var $4mfBs = parcelRequire("4mfBs");

});
parcelRegister("4mfBs", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b585de3836940d3$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $97yQ5 = parcelRequire("97yQ5");

var $fU62V = parcelRequire("fU62V");

var $5cKiX = parcelRequire("5cKiX");
var $fK3tS = parcelRequire("fK3tS");

var $9dYEz = parcelRequire("9dYEz");

var $fyJNx = parcelRequire("fyJNx");

var $35T7J = parcelRequire("35T7J");

var $ateU0 = parcelRequire("ateU0");
parcelRequire("26FlP");
var $8Hawo = parcelRequire("8Hawo");
class $2b585de3836940d3$export$b35804e181be10e8 extends $bSJIT.PureComponent {
    attachedFiles() {
        const { collection: collection, mediaClientConfig: mediaClientConfig, intl: intl, uploadedAttachments: uploadedAttachments } = this.props;
        if (uploadedAttachments && uploadedAttachments.length) return /*#__PURE__*/ $bSJIT.createElement((0, $35T7J.MediaClientProvider), {
            clientConfig: mediaClientConfig
        }, /*#__PURE__*/ $bSJIT.createElement($2b585de3836940d3$var$AttachedFilesContainer, null, uploadedAttachments.map((file)=>{
            const identifier = {
                mediaItemType: 'file',
                id: file.id || '',
                collectionName: collection
            };
            const removeLabel = intl.formatMessage((0, $ateU0.default).attachmentRemoveLabel);
            const actions = [
                {
                    handler: this.onRemoveAttachedListener(file),
                    label: removeLabel,
                    icon: /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9dYEz))), {
                        label: "",
                        size: "medium",
                        spacing: "compact"
                    })
                }
            ];
            return /*#__PURE__*/ $bSJIT.createElement($2b585de3836940d3$export$d3ce619e8161bad8, {
                key: file.id
            }, /*#__PURE__*/ $bSJIT.createElement((0, $fyJNx.default), {
                mediaClientConfig: mediaClientConfig,
                appearance: "image",
                identifier: identifier,
                actions: actions,
                // This is so we can fit 3 cards in one row in the request create paper.
                dimensions: {
                    width: '145px',
                    height: '145px'
                }
            }));
        })));
        return null;
    }
    render() {
        const { uploadsInProgress: uploadsInProgress, failedUploads: failedUploads, hasError: hasError, disabled: disabled, intl: intl } = this.props;
        return /*#__PURE__*/ $bSJIT.createElement("div", null, /*#__PURE__*/ $bSJIT.createElement($2b585de3836940d3$export$b319fb74e2dba8f9, {
            hasError: hasError
        }, /*#__PURE__*/ $bSJIT.createElement($2b585de3836940d3$var$DropzoneContent, null, /*#__PURE__*/ $bSJIT.createElement($2b585de3836940d3$var$DropzoneContentText, null, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $ateU0.default).attachmentField)), /*#__PURE__*/ $bSJIT.createElement((0, $97yQ5.Button), {
            isDisabled: disabled,
            onClick: this.onBrowseClicked,
            actionSubjectId: "browseAttachments",
            "aria-label": intl.formatMessage((0, $ateU0.default).attachmentFieldButtonAriaLabel)
        }, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $ateU0.default).attachmentFieldButton)), this.attachedFiles())), uploadsInProgress.map((uploading)=>/*#__PURE__*/ $bSJIT.createElement((0, $8Hawo.default), {
                key: uploading.id,
                ...uploading,
                onRemove: this.onRemoveInProgressListener(uploading)
            })), failedUploads.map((error)=>/*#__PURE__*/ $bSJIT.createElement((0, $8Hawo.default), {
                key: error.id,
                ...error,
                failed: true,
                onRemove: this.onRemoveErrorListener(error)
            })));
    }
    constructor(...args){
        super(...args), this.onRemoveAttachedListener = (file)=>{
            return ()=>{
                this.props.onRemoveAttached(file.id);
            };
        }, this.onRemoveInProgressListener = (file)=>{
            return ()=>{
                this.props.onRemoveInProgress(file.id, file.source);
            };
        }, this.onRemoveErrorListener = (file)=>{
            return ()=>{
                this.props.onRemoveError(file.id);
            };
        }, this.onBrowseClicked = ()=>{
            this.props.onBrowseClicked && this.props.onBrowseClicked();
        };
    }
}
var $2b585de3836940d3$export$2e2bcd8739ae039 = (0, $fK3tS.default)($2b585de3836940d3$export$b35804e181be10e8);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $2b585de3836940d3$var$DropzoneContent = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-dbcqad-0"
})`padding:${"var(--ds-space-200, 16px)"};text-align:center;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $2b585de3836940d3$var$DropzoneContentText = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-dbcqad-1"
})`margin-bottom:${"var(--ds-space-100, 8px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $2b585de3836940d3$var$AttachedFilesContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-dbcqad-2"
})`display:flex;flex-flow:row wrap;margin-top:${"var(--ds-space-200, 16px)"};text-align:left;`;
const $2b585de3836940d3$var$dropzoneErrorBorder = `solid ${"var(--ds-border-danger, #BF2600)"}`;
const $2b585de3836940d3$var$dropZoneDashedBorder = `dashed ${"var(--ds-border-input, #F4F5F7)"}`;
const $2b585de3836940d3$export$b319fb74e2dba8f9 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-dbcqad-3"
})`${$fU62V.borderRadius} border:${"var(--ds-border-width-selected, 2px)"} ${(props)=>props.hasError ? $2b585de3836940d3$var$dropzoneErrorBorder : $2b585de3836940d3$var$dropZoneDashedBorder};`;
const $2b585de3836940d3$export$d3ce619e8161bad8 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-dbcqad-4"
})`margin:0 ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} 0;`;

});
parcelRegister("fyJNx", function(module, exports) {
$parcel$export(module.exports, "default", () => $78d3d7a23857cdc1$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $deAR2 = parcelRequire("deAR2");

var $gdUUy = parcelRequire("gdUUy");

var $1DGz6 = parcelRequire("1DGz6");

var $b2ees = parcelRequire("b2ees");
const $78d3d7a23857cdc1$var$MediaCardContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext({});
const $78d3d7a23857cdc1$var$CardLoadingWithContext = ()=>{
    const props = (0, $bSJIT.useContext)($78d3d7a23857cdc1$var$MediaCardContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $b2ees.CardLoading), {
        ...props,
        interactionName: "media-card-async-loading"
    });
};

function $78d3d7a23857cdc1$var$loadCardWithMediaClient() {
    return (parcelRequire("iGQv0"));
}
const $78d3d7a23857cdc1$var$MediaCardWithMediaClientLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: ()=>$78d3d7a23857cdc1$var$loadCardWithMediaClient().then((mod)=>mod.CardWithMediaClient),
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($78d3d7a23857cdc1$var$CardLoadingWithContext, null)
});
const $78d3d7a23857cdc1$var$MediaCardWithMediaClientLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).lazy(()=>$78d3d7a23857cdc1$var$loadCardWithMediaClient().then((mod)=>({
            default: mod.CardWithMediaClient
        })));
const $78d3d7a23857cdc1$var$CardLoader = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1DGz6.default), {
        name: "media-card",
        mode: "list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($78d3d7a23857cdc1$var$MediaCardContext.Provider, {
        value: props
    }, (0, $gdUUy.fg)('platform_media_react19_support') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($78d3d7a23857cdc1$var$CardLoadingWithContext, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($78d3d7a23857cdc1$var$MediaCardWithMediaClientLazy, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($78d3d7a23857cdc1$var$MediaCardWithMediaClientLoadable, props)));
};
$78d3d7a23857cdc1$var$CardLoader.preload = ()=>{
    if ((0, $gdUUy.fg)('platform_media_react19_support')) $78d3d7a23857cdc1$var$loadCardWithMediaClient().then(()=>{});
    else {
        var _MediaCardWithMediaCl;
        (_MediaCardWithMediaCl = $78d3d7a23857cdc1$var$MediaCardWithMediaClientLoadable.preload) === null || _MediaCardWithMediaCl === void 0 || _MediaCardWithMediaCl.call($78d3d7a23857cdc1$var$MediaCardWithMediaClientLoadable);
    }
};
var $78d3d7a23857cdc1$export$2e2bcd8739ae039 = $78d3d7a23857cdc1$var$CardLoader;

});
parcelRegister("b2ees", function(module, exports) {
$parcel$export(module.exports, "CardLoading", () => $5cb084c50dfe3d13$export$5d25853fd6bdf402);

var $bSJIT = parcelRequire("bSJIT");

var $ljFME = parcelRequire("ljFME");

var $Ta6C9 = parcelRequire("Ta6C9");

var $cw1fH = parcelRequire("cw1fH");
const $5cb084c50dfe3d13$export$5d25853fd6bdf402 = ({ dimensions: dimensionsProp, testId: testId, interactionName: interactionName })=>{
    const dimensions = (0, $Ta6C9.getDimensionsWithDefault)(dimensionsProp);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cw1fH.Wrapper), {
        "data-testid": testId || 'media-card-loading',
        "data-test-loading": true,
        dimensions: dimensions,
        "data-vc": "media-card-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ljFME.LoadingBar), {
        interactionName: interactionName || 'media-card-loading'
    }));
};

});
parcelRegister("ljFME", function(module, exports) {
$parcel$export(module.exports, "LoadingBar", () => $d7e29441a6d1fe20$export$6665614bc5d690f6);
/* loadingBar.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $f0Pt4 = parcelRequire("f0Pt4");
var $4vLTk = parcelRequire("4vLTk");

var $cyIUy = parcelRequire("cyIUy");
const $d7e29441a6d1fe20$var$TICK_INTERVAL_MS = 1000;
const $d7e29441a6d1fe20$var$STATIC_PROGRESS_VALUE = 0.9;
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ const $d7e29441a6d1fe20$var$useLayoutEffect = typeof window === 'undefined' ? (0, $bSJIT.useEffect) : (0, $bSJIT.useLayoutEffect);
const $d7e29441a6d1fe20$var$messages = (0, $f0Pt4.defineMessages)({
    loadingBarLabel: {
        id: 'fabric.media.loading_bar_label',
        defaultMessage: 'Loading',
        description: 'Aria label for the loading bar shown while a media card is loading'
    }
});
const $d7e29441a6d1fe20$var$trackStyles = null;
const $d7e29441a6d1fe20$var$fillStyles = null;
const $d7e29441a6d1fe20$var$clampToPercent = (progress)=>Math.min(1, Math.max(0, progress)) * 100;
const $d7e29441a6d1fe20$export$6665614bc5d690f6 = ({ animationDisabled: animationDisabled = false, testId: testId, interactionName: interactionName })=>{
    const intl = (0, $4vLTk.default)();
    const [progress, setProgress] = (0, $bSJIT.useState)(animationDisabled ? $d7e29441a6d1fe20$var$STATIC_PROGRESS_VALUE : 0);
    const intervalRef = (0, $bSJIT.useRef)();
    const interactionContext = (0, $bSJIT.useContext)((0, $cyIUy.default));
    $d7e29441a6d1fe20$var$useLayoutEffect(()=>{
        if (interactionContext != null) return interactionContext.hold(interactionName);
    }, [
        interactionContext,
        interactionName
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (animationDisabled) {
            setProgress($d7e29441a6d1fe20$var$STATIC_PROGRESS_VALUE);
            return;
        }
        intervalRef.current = setInterval(()=>{
            setProgress((prev)=>{
                if (prev < 0.1) return prev + 0.1;
                else if (prev < 0.6) return prev + 0.35;
                else if (prev < 0.9) return prev + 0.1;
                clearInterval(intervalRef.current);
                return prev;
            });
        }, $d7e29441a6d1fe20$var$TICK_INTERVAL_MS);
        return ()=>clearInterval(intervalRef.current);
    }, [
        animationDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        role: "progressbar",
        "aria-valuenow": progress,
        "aria-label": intl.formatMessage($d7e29441a6d1fe20$var$messages.loadingBarLabel),
        "data-testid": testId,
        className: (0, $9fU1q.default)([
            "_1reo15vq _18m915vq _2rko1rr0 _kqswstnw _94n5u2gc _1bsb1lk2 _1ltv1ghs _4t3ii2wt _bfhki8nm"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        style: {
            width: `${$d7e29441a6d1fe20$var$clampToPercent(progress)}%`
        },
        className: (0, $9fU1q.default)([
            "_2rko1rr0 _v564aq9m _1e0c1ule _4t3i1osq _bfhk10ef"
        ])
    }));
};

});

parcelRegister("Ta6C9", function(module, exports) {
$parcel$export(module.exports, "getDimensionsWithDefault", () => $495ceed8aac696eb$export$36acad525b1fb57b);
const $495ceed8aac696eb$export$36acad525b1fb57b = (dimensions = {
    width: '100%',
    height: '100%'
})=>{
    return {
        height: typeof dimensions.height === 'number' ? `${dimensions.height}px` : dimensions.height,
        width: typeof dimensions.width === 'number' ? `${dimensions.width}px` : dimensions.width
    };
};

});

parcelRegister("cw1fH", function(module, exports) {
$parcel$export(module.exports, "Wrapper", () => $f6d0df9b2c173384$export$e6dfd72ab29f8598);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $gXAfF = parcelRequire("gXAfF");
const $f6d0df9b2c173384$export$e6dfd72ab29f8598 = (props)=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: (0, $gXAfF.wrapperStyles)({
            dimensions: props.dimensions
        }),
        ...props
    }, props.children));
};

});
parcelRegister("gXAfF", function(module, exports) {
$parcel$export(module.exports, "wrapperStyles", () => $9ee7ec6ea09cf5f4$export$491e6397d7c1480b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9dQre = parcelRequire("9dQre");

var $kCE0b = parcelRequire("kCE0b");
const $9ee7ec6ea09cf5f4$export$491e6397d7c1480b = ({ dimensions: dimensions })=>/*#__PURE__*/ (0, $9dQre.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $kCE0b.center), "position:relative;background:var(--ds-surface-sunken, #F8F8F8);color:var(--ds-icon, #292A2E);", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $kCE0b.borderRadius), {
        maxHeight: '100%',
        maxWidth: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: dimensions.width,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: dimensions.height
    });

});
parcelRegister("kCE0b", function(module, exports) {
$parcel$export(module.exports, "center", () => $e6f3d73a7bae77e8$export$3481c78889e8fbe8);
$parcel$export(module.exports, "borderRadius", () => $e6f3d73a7bae77e8$export$7a57f79000377ca2);
const $e6f3d73a7bae77e8$export$3481c78889e8fbe8 = `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $e6f3d73a7bae77e8$export$7a57f79000377ca2 = `
  border-radius: ${"var(--ds-radius-small, 3px)"};
`;
const $e6f3d73a7bae77e8$export$a98155aef1bfd63 = `
  border-bottom-left-radius: ${"var(--ds-radius-small, 3px)"};
  border-bottom-right-radius: ${"var(--ds-radius-small, 3px)"};
`;
const $e6f3d73a7bae77e8$export$24656b269d8df7d6 = 'cubic-bezier(0.645, 0.045, 0.355, 1)';

});




parcelRegister("iGQv0", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("cqzIS"),
    $kOunM("hyEGg"),
    $kOunM("eyRof")
]).then(()=>parcelRequire('3NCBI'));

});


parcelRegister("ateU0", function(module, exports) {
$parcel$export(module.exports, "default", () => $7cb0e5ff71336c6d$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $7cb0e5ff71336c6d$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    attachmentField: {
        defaultMessage: 'Drag and drop files, paste screenshots, or browse',
        description: 'Label for the drag-and-drop attachments area on the request creation form',
        id: 'cv.request.create.form.field.attachment'
    },
    attachmentFieldButton: {
        defaultMessage: 'Browse',
        description: 'Label for button to open browse modal in attachments area',
        id: 'cv.request.create.form.field.attachment.button'
    },
    attachmentFieldButtonAriaLabel: {
        defaultMessage: 'Browse your device for attachments',
        description: 'Aria Label for button to open browse modal in attachments area',
        id: 'cv.request.create.form.field.attachment.button.aria.label'
    },
    attachmentPreviewLabel: {
        defaultMessage: 'Attachment',
        description: 'Label for the attachment preview image',
        id: 'cv.request.create.form.field.attachment.preview.label'
    },
    attachmentRemoveLabel: {
        defaultMessage: 'Remove attachment',
        description: 'Label for button to remove an attachment',
        id: 'cv.request.create.form.field.attachment.remove.label'
    },
    attachmentUploadFailed: {
        defaultMessage: 'Upload failed',
        description: 'Message to show when an individual attachment upload fails',
        id: 'cv.request.create.form.field.attachment.upload.failed'
    }
});

});

parcelRegister("26FlP", function(module, exports) {
$parcel$export(module.exports, "UploadStatus", () => (parcelRequire("8Hawo")).default);

var $8Hawo = parcelRequire("8Hawo");

});
parcelRegister("8Hawo", function(module, exports) {
$parcel$export(module.exports, "default", () => $40cc00d80042106d$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $9K7mZ = parcelRequire("9K7mZ");

var $fU62V = parcelRequire("fU62V");

var $fK3tS = parcelRequire("fK3tS");
parcelRequire("iQLQJ");
var $8TZib = parcelRequire("8TZib");

var $aFV7z = parcelRequire("aFV7z");

var $9dYEz = parcelRequire("9dYEz");

var $lwuFt = parcelRequire("lwuFt");

var $ateU0 = parcelRequire("ateU0");

var $fnHkv = parcelRequire("fnHkv");
class $40cc00d80042106d$export$f7cdc72f22de79df extends $bSJIT.PureComponent {
    renderProgressBar() {
        if (this.props.failed) return /*#__PURE__*/ $bSJIT.createElement($40cc00d80042106d$var$UploadProgressBarContainer, null, /*#__PURE__*/ $bSJIT.createElement((0, $fnHkv.UploadProgressBarFailure), null));
        const progress = this.props.progress || 0;
        return /*#__PURE__*/ $bSJIT.createElement($40cc00d80042106d$var$UploadProgressBarContainer, null, /*#__PURE__*/ $bSJIT.createElement((0, $fnHkv.UploadProgressBarInProgress), {
            progress: progress
        }));
    }
    renderRightIcon() {
        const iconProps = {
            label: this.props.intl.formatMessage((0, $ateU0.default).attachmentRemoveLabel),
            primaryColor: "var(--ds-icon, #42526E)"
        };
        return /*#__PURE__*/ $bSJIT.createElement((0, $8TZib.default), {
            onClick: this.onRemove,
            actionSubjectId: "removeAttachment"
        }, /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9dYEz))), {
            ...iconProps,
            size: "medium",
            spacing: "spacious"
        }));
    }
    render() {
        const { name: name, preview: preview, failed: failed, error: error, intl: intl } = this.props;
        const icon = preview ? /*#__PURE__*/ $bSJIT.createElement($40cc00d80042106d$var$UploadStatusPreview, {
            alt: intl.formatMessage((0, $ateU0.default).attachmentRemoveLabel),
            src: preview
        }) : /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lwuFt))), {
            label: intl.formatMessage((0, $ateU0.default).attachmentRemoveLabel),
            size: "medium",
            spacing: "spacious"
        });
        const content = /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement($40cc00d80042106d$var$AttachmentContainer, null, /*#__PURE__*/ $bSJIT.createElement($40cc00d80042106d$var$AttachmentFileName, {
            title: name
        }, name), failed && /*#__PURE__*/ $bSJIT.createElement($40cc00d80042106d$var$AttachmentMessage, {
            title: error
        }, intl.formatMessage((0, $ateU0.default).attachmentUploadFailed))), this.renderProgressBar());
        return /*#__PURE__*/ $bSJIT.createElement((0, $aFV7z.IconCardLayout), {
            leftIcon: icon,
            content: content,
            rightIcon: this.renderRightIcon()
        });
    }
    constructor(...args){
        super(...args), this.onRemove = ()=>{
            this.props.onRemove && this.props.onRemove();
        };
    }
}
var $40cc00d80042106d$export$2e2bcd8739ae039 = (0, $fK3tS.default)($40cc00d80042106d$export$f7cdc72f22de79df);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $40cc00d80042106d$var$AttachmentContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1rt7zfu-0"
})`margin-top:${"var(--ds-space-100, 8px)"};display:flex;flex-flow:row no-wrap;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $40cc00d80042106d$var$AttachmentFileName = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1rt7zfu-1"
})`${$fU62V.clamp} margin-bottom:${"var(--ds-space-100, 8px)"};flex:1 1 auto;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $40cc00d80042106d$var$AttachmentMessage = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1rt7zfu-2"
})`flex:0 0 auto;margin-left:${"var(--ds-space-100, 8px)"};white-space:nowrap;color:${"var(--ds-text-subtlest, #5E6C84)"};`;
const $40cc00d80042106d$var$UPLOAD_STATUS_ICON_SIZE = $9K7mZ.multiple(4).px;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $40cc00d80042106d$var$UploadStatusPreview = /*#__PURE__*/ (0, $4v2A7.default).img.withConfig({
    componentId: "sc-1rt7zfu-3"
})`height:${$40cc00d80042106d$var$UPLOAD_STATUS_ICON_SIZE};width:${$40cc00d80042106d$var$UPLOAD_STATUS_ICON_SIZE};`;
// Progress Bar - Replace with AtlasKit version when available
const $40cc00d80042106d$var$progressBarHeight = '6px';
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $40cc00d80042106d$var$UploadProgressBarContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1rt7zfu-4"
})`${$fU62V.borderRadius};margin-bottom:${"var(--ds-space-100, 8px)"};height:${$40cc00d80042106d$var$progressBarHeight};width:100%;background:${"var(--ds-background-neutral, rgba(9, 30, 66, 0.08))"};`;

});
parcelRegister("iQLQJ", function(module, exports) {
$parcel$export(module.exports, "UnstyledButton", () => (parcelRequire("8TZib")).default);

var $8TZib = parcelRequire("8TZib");

});
parcelRegister("8TZib", function(module, exports) {
$parcel$export(module.exports, "default", () => $76d9f6ac545824bd$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");

var $eygX7 = parcelRequire("eygX7");

var $fU62V = parcelRequire("fU62V");
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $76d9f6ac545824bd$var$UnstyledButton = /*#__PURE__*/ (0, $4v2A7.default)((0, $eygX7.HtmlButton)).withConfig({
    componentId: "sc-q2pk8z-0"
})`${$fU62V.focusRing.default};cursor:pointer;position:relative;background-color:transparent;color:transparent;border:0;padding:0;&::-moz-focus-inner{border:0;}`;
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
$76d9f6ac545824bd$export$2e2bcd8739ae039 = $76d9f6ac545824bd$var$UnstyledButton;

});
parcelRegister("eygX7", function(module, exports) {
$parcel$export(module.exports, "HtmlButton", () => $f220733f3bdd628c$export$bdf65d68278e6d70);

var $bSJIT = parcelRequire("bSJIT");

var $hWsdJ = parcelRequire("hWsdJ");
const $f220733f3bdd628c$var$SplicedPropsButton = ({ actionSubjectId: actionSubjectId, createAnalyticsEvent: createAnalyticsEvent, children: children, ...props })=>/*#__PURE__*/ $bSJIT.createElement("button", props, children);
const $f220733f3bdd628c$export$bdf65d68278e6d70 = (0, $hWsdJ.default)('button', {
    onClick: ()=>({
            action: 'clicked'
        })
})($f220733f3bdd628c$var$SplicedPropsButton);

});



parcelRegister("fnHkv", function(module, exports) {
$parcel$export(module.exports, "UploadProgressBarInProgress", () => $07355e5a6e9f3884$export$9840f8d44dcda9a0);
$parcel$export(module.exports, "UploadProgressBarFailure", () => $07355e5a6e9f3884$export$c1e76efeaccc00f1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");

var $fU62V = parcelRequire("fU62V");
// Progress Bar - Replace with AtlasKit version when available
const $07355e5a6e9f3884$var$progressBarHeight = '6px';
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $07355e5a6e9f3884$var$UploadProgressBar = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-2qvjd8-0"
})`${$fU62V.borderRadius};height:${$07355e5a6e9f3884$var$progressBarHeight};`;
const $07355e5a6e9f3884$export$9840f8d44dcda9a0 = $07355e5a6e9f3884$var$UploadProgressBar.extend`
    width: ${(props)=>props.progress || 0}%;
    background: ${"var(--ds-background-neutral-bold, #172B4D)"};
`;
const $07355e5a6e9f3884$export$c1e76efeaccc00f1 = $07355e5a6e9f3884$var$UploadProgressBar.extend`
    width: 100%;
    background: ${"var(--ds-background-danger-bold, #FF5630)"};
`;

});







//# sourceMappingURL=attachments.8ffd7b38.js.map
